import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useContext, useEffect, useState } from "react";
import { contestationPeriodsService } from "../../services/ContestationPeriodsService";
import { formatDate } from "../../config/Config";
import { AppDB } from "../../App";
import ScreenLoader from "../../componets/ScreenLoader";

export default function () {
    var { permission, toast } = useContext(AppDB);

    var raw_form = {
        "name": "",
        "description": "",
        "registrationYear": "",
        "startDate": "",
        "endDate": "",
        isEdit: false,
        show: false
    }
    var [form, setForm] = useState(raw_form)
    var [refresh, setRefresh] = useState(false)
    var [loading, setLoading] = useState(false)
    var [errors, setErrors] = useState({})
    var [tableData, setTableData] = useState([])

    function on_input(e) {
        var { value, name } = e.target



        if (name === "startDate") {
            let start = new Date(value);
            // Add 12 months
            start.setMonth(start.getMonth() + 12);
            // Format the date as YYYY-MM-DD

            setForm({ ...form, [name]: value, endDate: start })
        }else{
            setForm({ ...form, [name]: value})
        }
        if (`${name}`.trim().length === 0) {
            setErrors({ ...errors, [name]: "required" })
        } else {
            delete errors[name];
            setErrors({ ...errors })
        }
    }

    useEffect(() => {
        setLoading(true)
        contestationPeriodsService.getContestationPeriods().then(res => {
            setTableData(res)
            setLoading(false)
        })
    }, [refresh])

    function onSubmit() {



        var err = false
        for (const [key, value] of Object.entries(form)) {
            if (typeof value === 'string' && value.trim() === '') {
                errors[key] = "required";
                err = true;
            }
        }

        if (err) {
            return setErrors({ ...errors })
        } else {
            setErrors({})
        }


        function responseHandler(res) {
            setLoading(false)
            if (res.success) {
                setRefresh(!refresh)
                setForm(raw_form)
                setErrors({})
                toast.show({
                    severity: "success",
                    detail: `Membership period ${form.isEdit ? "updated" : "created"}`,
                    life: 2500
                });
            } else {

                toast.show({
                    severity: "error",
                    detail: res.message,
                    life: 2500
                })
            }
        }

        setLoading(true)
        var clone = { ...form }
        clone.registrationYear = clone?.registrationYear?.getFullYear()
        if (form.isEdit) {
            contestationPeriodsService.updateContestationPeriods(clone).then(res => {
                responseHandler(res)
            })
        } else {
            contestationPeriodsService.createContestationPeriods(clone).then(res => {
                responseHandler(res)

            })
        }
    }

    return (<>
        <ScreenLoader visible={loading} />
        <Dialog
            style={{ width: "100%", maxWidth: "600px" }}
            header={<h4>{form.isEdit ? "Update" : "Create"} Membership Period</h4>} onHide={() => {
                setForm(raw_form)
                setErrors({})
            }} visible={form.show}
            footer={<>
                <Button className="mr-2" label="Submit" onClick={onSubmit} />

                <Button className="p-button-danger" label="Close" onClick={() => {
                    setForm(raw_form)
                    setErrors({})
                }} />
            </>}
        >
            <br />
            <div className="grid">
                <div className="col-12">
                    <label >Name<span style={{ color: "red" }}>*</span></label>
                    <InputText value={form.name} onChange={(e => on_input(e))} name="name" className="w-full" />
                    <small style={{ width: "100%" }} className="p-error">
                        {errors?.name}
                    </small>
                </div>
                <div className="col-12">
                    <label >Description<span style={{ color: "red" }}>*</span></label>
                    <InputText value={form.description} onChange={(e => on_input(e))} name="description" className="w-full" />
                    <small style={{ width: "100%" }} className="p-error">
                        {errors?.description}
                    </small>
                </div>
                <div className="col-12">
                    <label >Registration Year<span style={{ color: "red" }}>*</span></label>
                    <Calendar view="year" dateFormat="yy" value={form.registrationYear} onChange={(e => on_input(e))} name="registrationYear" className="w-full" />
                    <small style={{ width: "100%" }} className="p-error">
                        {errors?.registrationYear}
                    </small>
                </div>
                <div className="col-12">
                    <label >Start Date<span style={{ color: "red" }}>*</span></label>
                    <Calendar value={form.startDate} onChange={(e => on_input(e))} name="startDate" className="w-full" />
                    <small style={{ width: "100%" }} className="p-error">
                        {errors?.startDate}
                    </small>
                </div>
                <div className="col-12">
                    <label >End Date<span style={{ color: "red" }}>*</span></label>
                    <Calendar value={form.endDate} onChange={(e => on_input(e))} name="endDate" className="w-full" />
                    <small style={{ width: "100%" }} className="p-error">
                        {errors?.endDate}
                    </small>
                </div>
            </div>
        </Dialog>
        <div className="card">
            <DataTable header={<>  <div className="flex justify-content-between align-items-center ">
                <h5>Membership Periods</h5>
                <Button onClick={() => { setForm({ ...raw_form, show: true }) }} label="Create" />
            </div>


            </>} value={tableData}>
                <Column field="name" header={"Name"} />
                <Column field="registrationYear" header={"Registration Year"} />
                <Column header={"Start Date"} body={e => formatDate(e.startDate)} />
                <Column header={"End Date"} body={e => formatDate(e.endDate)} />

                <Column header={"Action"} field="Action" body={(row) => <Button
                    style={{
                        textAlign: "center",
                        width: "30px",
                        height: "30px",
                    }}
                    icon={"pi pi-pencil"}
                    className=" p-button-rounded"
                    onClick={() => {
                        setForm({
                            ...raw_form, show: true, isEdit: true, ...row,
                            registrationYear: new Date(`1/1/${row.registrationYear}`),
                            startDate: new Date(row.startDate),
                            endDate: new Date(row.endDate),
                        })
                        setErrors({})
                    }}
                />}></Column>
            </DataTable>
        </div>
    </>)
}